import Home from "./pages/home/Home";

import { Person } from "@mui/icons-material";
import Profile from "./pages/profile/Profile";
import Login from "./pages/login/Login";
import Register from "./pages/register/Register";

function App() {
  return <Home />;
}

export default App;
